import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Environment } from '@environments';

@Component({
  selector: 'app-akky-pro-hero',
  templateUrl: './akky-pro-hero.component.html',
  styleUrls: ['./akky-pro-hero.component.css'],
  host: {
    class: 'py-5 d-flex flex-column justify-content-center align-items-center text-center'
  }
})
export class AkkyProHeroComponent implements OnInit
{
  @Input({required: true}) public title!: string;
  @Input() public subtitle?: string;
  @Input({required: true}) public backgroundColor!: string;
  @Input({required: true}) public textColor!: string;
  @Input({required: true}) public buttonText!: string;
  @Input({required: true}) public isSubtitleBold!: boolean;
  @Input({required: true}) public titleSize: string = '48px';
  @Input({required: true}) public subtitleSize: string = '20px';
  
  protected showAkkyProModal: boolean = false;

  protected safeUrl!: SafeResourceUrl;
  constructor( private sanitizer: DomSanitizer ) { }

  @HostBinding('style.background-color') public get setBackground(): string
  {
    return this.backgroundColor;
  }

  @HostBinding('style.color') public get setTextColor(): string
  {
    return this.textColor;
  }

  @HostBinding('style.min-height') public get setMinHeight(): string
  {
      return '472px';
  }

  @HostBinding('style.max-height') public get setMaxHeight(): string
  {
      return '554px';
  }

  public ngOnInit(): void
  {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(Environment.SalesForceAkkyProForm);
  }
}
